import { createStore } from 'vuex'
// Modules
import users from '@/store/modules/users'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    users,
  }
})
